import * as immutable from 'immutable';
import { USER_ACTIONS } from './user-actions.constant';
import { Ipractitioner } from '../interfaces/practitioner.interface';
import { IPatient } from '../interfaces/patient.interface';
import { GeneralStoreEntity } from '@ispm/core/entities/general-store.entity';
import { cloneDeep } from 'lodash';

export interface IuserState {
  patients: immutable.Map<string, IPatient>;
  practitioners: immutable.Map<string, Ipractitioner>;
  currentUser: any;
  organizationConfiguration: any;
  browserDetectedLanguage:string;
  reloadAdminWorkList:boolean;
  selectedFacilities: Array<any>;
  selectedFacilitiesString:string;
  association: string;
  applied:boolean;
  currentPatient?: any;
  currentPatientLink: string;
  currentPatientIdentifiers: any
}

const InitUserState: IuserState = {
  practitioners: immutable.Map(),
  patients: immutable.Map(),
  currentUser: { },
  organizationConfiguration: null,
  reloadAdminWorkList: false,
  browserDetectedLanguage:"en-US",
  selectedFacilities: [],
  selectedFacilitiesString:null,
  association:'managedByFacility',
  applied:false,
  currentPatient: null,
  currentPatientLink: null,
  currentPatientIdentifiers: null
}

export function userReducer(state: IuserState = InitUserState, action: any): IuserState {
  let newState;
  switch (action.type) {
    case USER_ACTIONS.INIT_USER_STATE:
      return InitUserState;
    case USER_ACTIONS.UPDATE_PATIENT:
      newState = Object.assign({ }, state);
      // Even after navigating to other patients from worklist all the previously selected patient data is retained
      // None of the patient data is used anywhere
      // So removing all other patient data when current patient is updated.
      newState.patients = immutable.Map();
      newState.patients = newState.patients.set(action.payload.id, action.payload.data);
      return newState;
    case USER_ACTIONS.UPDATE_CURRENT:
      return (<GeneralStoreEntity> action).upsert(state, 'currentUser');
    case USER_ACTIONS.SET_CURRENT_USER:
      newState = Object.assign({ }, state);
      newState.currentUser = action.payload;
      return newState;
    case USER_ACTIONS.REMOVE_PATIENT:
      newState = Object.assign({ }, state);
      newState.patients = newState.patients.remove(action.payload.id);
      return newState;
    case USER_ACTIONS.CLEAR_PATIENT:
      newState = Object.assign({ }, state);
      newState.patients = immutable.Map();
      newState.currentPatient = null;
      newState.currentPatientLink = null;
      newState.currentPatientIdentifiers = null;
      return newState;
    case USER_ACTIONS.UPDATE_PRACTITIONER:
      return { ...state, practitioners: state.practitioners.set(action.payload.id, action.payload.data)};
    case USER_ACTIONS.REMOVE_PRACTITIONER:
      newState = Object.assign({ }, state);
      newState.practitioners = newState.practitioners.remove(action.payload.id);
      return newState;
    case USER_ACTIONS.SET_ORGANIZATION_CONFIGURATION:
      newState = Object.assign({ }, state);
      newState.organizationConfiguration = action.payload;
      return newState;
    case USER_ACTIONS.SET_BROWSER_DETECTED_LANG:
      newState = Object.assign({ }, state);
      newState.browserDetectedLanguage = action.payload.langCode;
      return newState;
    case USER_ACTIONS.SET_RELOAD_ADMIN_WORKLIST:
      newState = Object.assign({ }, state);
      newState.reloadAdminWorkList = action.payload.reload;
       return newState;
    case USER_ACTIONS.UPDATE_SELECTED_FACILITIES:
      newState = Object.assign({ }, state);
      newState.selectedFacilities = action.payload.selectedFacilities;
      newState.selectedFacilitiesString = action.payload.selectedFacilitiesString;
      newState.association = action.payload.association;
      newState.applied = action.payload.applied;
      return newState;
    case USER_ACTIONS.SET_CURRENT_PATIENT:
      newState = Object.assign({ }, state);
      newState.currentPatient = action.payload.patientData;
      if (action.payload.patientData && Array.isArray(action.payload.patientData.name) && action.payload.patientData.name[0]){
        newState.currentPatient.fullName = action.payload.patientData.name[0].text;
      }
      if (action.payload.patientData && Array.isArray(action.payload.patientData.identifier)){
        const mrnItem = action.payload.patientData.identifier.find(data=> data.hasOwnProperty("MRN"));
        if (mrnItem){
          newState.currentPatient.MRN = mrnItem.MRN;
        }
      }
      return newState;

    case USER_ACTIONS.UPDATE_ORGANIZATION_CONFIGURATION_APPLICATIONS:
      newState = cloneDeep(state);
      newState.organizationConfiguration.applications = [...action.payload];
      return newState;
    case USER_ACTIONS.SELECTED_FACILITY:
      newState = Object.assign({ }, state);
      newState['selectedFacility'] = action.payload;
      return newState;

    case USER_ACTIONS.SET_CURRENT_PATIENTLINK:
      newState = Object.assign({ }, state);
      newState.currentPatientLink = action.payload;
      return newState;
    case USER_ACTIONS.SET_CURRENT_PATIENT_IDENTIFIERS:
      newState = Object.assign({ }, state);
      newState.currentPatientIdentifiers = action.payload.data
      return newState;

    default:
      return state;
  }
}
